import requests from "./httpService"

const TrustedCompaniesServices = {
    getAllTrustedCompanies: async () => {
        return requests.get('/Klitespace/getallcompanylogo')
    },

    getTrustedCompanyById: async (id) => {
        return requests.get(`/Klitespace/getcompanylogo/${id}`)
    },

    createTrustedCompany: async (data) => {
        return requests.post('/Klitespace/createcompanylogo', data)
    },

    editTrustedCompany: async (id, data) => {
        return requests.put(`/Klitespace/updatecompanylogo/${id}`, data)
    },

    deleteTrustedCompany: async (id) => {
        return requests.delete(`/Klitespace/deletecompanylogo/${id}`)
    }
}

export default TrustedCompaniesServices